import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const POINTS = [
  { name: "Fortaleza", detail: "Sede e atendimento principal", coords: [-3.7319, -38.5267], main: true },
  { name: "Caucaia", detail: "Região Metropolitana", coords: [-3.7361, -38.6531] },
  { name: "Maracanaú", detail: "Região Metropolitana", coords: [-3.8767, -38.6256] },
  { name: "Aquiraz", detail: "Região Metropolitana", coords: [-3.9014, -38.3911] },
  { name: "Eusébio", detail: "Região Metropolitana", coords: [-3.87, -38.445] },
  { name: "Itaitinga", detail: "Região Metropolitana", coords: [-3.7833, -38.475] },
];

const CENTER = [-3.8, -38.55];

export default function MapView() {
  const ref = useRef(null);

  useEffect(() => {
    const map = L.map(ref.current, {
      zoomControl: false,
      scrollWheelZoom: false,
    });
    map.setView(CENTER, 10);

    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(map);

    POINTS.forEach((p) => {
      L.circleMarker(p.coords, {
        radius: p.main ? 10 : 6,
        color: "#38bdf8",
        weight: 2,
        fillColor: "#0062ff",
        fillOpacity: p.main ? 0.9 : 0.5,
      })
        .addTo(map)
        .bindPopup(`<b>${p.name}</b><br/>${p.detail}`);
    });

    L.control.zoom({ position: "bottomright" }).addTo(map);

    return () => map.remove();
  }, []);

  return (
    <div
      ref={ref}
      data-testid="coverage-map"
      className="map-dark h-[360px] lg:h-[480px] w-full rounded-2xl z-0"
    />
  );
}
